import React from "react";
import {Website} from "../layouts/Website";
import {PageTitle} from "../components/shared/PageTitle";
import {Box, Container, Grid, Typography} from "@mui/material";
import {programMap} from "../data/programMap";
import {CardProgramma} from "../components/Programma/CardProgramma";
import {homeMap} from "../data/homeMap";
import {HomeTextBlock} from "../components/shared/HomeTextBlock";

export const Curiosita = () => {
    return (
        <Website>
            <Container sx={{py: 5}}>
                <PageTitle title={'Curiosità'} image={'icon-curiosita'}/>
                {
                    homeMap.map((part, index) =>
                        <Box key={part.title} sx={{pb: 2}} key={part.title}>
                            {
                                part.sections.map((section, index) =>
                                    <HomeTextBlock section={section} key={section.title} direction={'row'}/>
                                )
                            }
                        </Box>
                    )
                }
            </Container>
        </Website>
    )
}
